"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelStyle = exports.TabContentStyle = exports.DefaultTabLabelStyleName = exports.GetTabLabelContainerStyles = exports.TabStyleName = exports.GetTabListStyles = exports.TabPanelContainerStyles = exports.TabPanelScrollContainerStyles = exports.RootStyleName = exports.NonAnchorTabPanelStyles = exports.TabsWidgetDimensions = exports.Hidden = exports.Visible = void 0;
var tslib_1 = require("tslib");
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var PreventUserSelect_1 = require("../../styles/PreventUserSelect");
var TabStyles_1 = require("../../styles/TabStyles");
var TextEllipsis_1 = require("../../styles/TextEllipsis");
var Spacing = TabStyles_1.TabStyles.Spacing;
var Colors = TabStyles_1.TabStyles.Colors;
var FontColors = TabStyles_1.TabStyles.Typography.Color;
// Only the active tab should be visible, all others should be hidden
exports.Visible = { visibility: 'visible' };
exports.Hidden = { visibility: 'hidden' };
exports.TabsWidgetDimensions = {
    tabLabelPadding: Spacing.ExtraLargeSpace,
    textOnlyTabListHeight: 42,
    iconAndTextTabListHeight: 54,
    tabIndicatorHeight: 3
};
// The client specifies which tab panel we should anchor the tab widget height to. It's often the tallest tab panel,
// so that the dialog will always be tall enough and will not resize when switching tabs
exports.NonAnchorTabPanelStyles = {
    position: 'absolute',
    width: '100%',
    left: '0',
    top: '0'
};
exports.RootStyleName = TypeStyle.style({
    display: 'flex',
    flexDirection: 'column',
});
exports.TabPanelScrollContainerStyles = function (padding) { return ({
    overflowY: 'auto',
    padding: padding !== null && padding !== void 0 ? padding : Spacing.LargeSpace,
    position: 'relative',
    WebkitOverflowScrolling: 'touch',
}); };
exports.TabPanelContainerStyles = {
    position: 'relative',
};
exports.GetTabListStyles = function (isAnIconDefinedInTabs, tabHeightOverride) {
    return tslib_1.__assign({ display: 'flex', flexShrink: 0, fontSize: isAnIconDefinedInTabs ? TabStyles_1.TabStyles.Typography.Sizing.Tiny : TabStyles_1.TabStyles.Typography.Sizing.Default, height: tabHeightOverride !== null && tabHeightOverride !== void 0 ? tabHeightOverride : (isAnIconDefinedInTabs ? exports.TabsWidgetDimensions.iconAndTextTabListHeight : exports.TabsWidgetDimensions.textOnlyTabListHeight) }, PreventUserSelect_1.PreventUserSelect);
};
exports.TabStyleName = TypeStyle.style({
    boxSizing: 'border-box',
    display: 'inline-block',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    $nest: {
        '&::after': {
            backgroundColor: 'transparent',
            content: "\"\"",
            height: exports.TabsWidgetDimensions.tabIndicatorHeight,
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
        },
        '&:hover::after': { backgroundColor: Colors.L5 },
        '&[aria-selected="true"]::after': { backgroundColor: Colors.L8 },
        '&&:active::after': { backgroundColor: Colors.L9 },
    }
});
exports.GetTabLabelContainerStyles = function (horizontalPadding) {
    return {
        alignItems: 'center',
        display: 'flex',
        height: '100%',
        justifyContent: 'center',
        paddingRight: horizontalPadding !== null && horizontalPadding !== void 0 ? horizontalPadding : exports.TabsWidgetDimensions.tabLabelPadding,
        paddingLeft: horizontalPadding !== null && horizontalPadding !== void 0 ? horizontalPadding : exports.TabsWidgetDimensions.tabLabelPadding,
    };
};
exports.DefaultTabLabelStyleName = TypeStyle.style(tslib_1.__assign({ color: FontColors.PrimaryLight, width: '100%' }, TextEllipsis_1.TextEllipsis));
exports.TabContentStyle = {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center'
};
exports.LabelStyle = tslib_1.__assign({ display: 'block' }, TextEllipsis_1.TextEllipsis);
//# sourceMappingURL=TabsWidgetStyles.js.map